import { del, get, post, put, urlApiTegra } from "../../../service/api";

const url = urlApiTegra;


async function getSeniority(token: string) {
    return get(`${url}/seniority`, token)
}

async function postSeniority (body: any, token: string ) {
    return post(`${url}/seniority`, body,  token) 
}

async function delSeniority (id: number, token: string) {
    return del(`${url}/seniority/${id}`, token)
}

async function putSeniority(body: any, id: number, token: string) {
    return put(`${url}/seniority/${id}`, body, token)
}

export {
    postSeniority,
    getSeniority,
    delSeniority,
    putSeniority,
}